import React from 'react';
import {observer} from 'mobx-react';
import CandidateStatus from 'main/components/tables/interactive/components/fancy_filter/filter_selector/CandidateStatus';
import CandidateTags from 'main/components/tables/interactive/components/fancy_filter/filter_selector/CandidateTags';
import CandidatePositions from 'main/components/tables/interactive/components/fancy_filter/filter_selector/CandidatePositions';
import CandidateRatings from 'main/components/tables/interactive/components/fancy_filter/filter_selector/CandidateRatings';
import Location from 'main/components/tables/interactive/components/fancy_filter/filter_selector/Location';
import Department from 'main/components/tables/interactive/components/fancy_filter/filter_selector/Department';
import EmploymentStatus from 'main/components/tables/interactive/components/fancy_filter/filter_selector/EmploymentStatus';
import EmploymentType from 'main/components/tables/interactive/components/fancy_filter/filter_selector/EmploymentType';
import GoalEmployee from 'main/components/tables/interactive/components/fancy_filter/filter_selector/GoalEmployee';
import GoalStatus from 'main/components/tables/interactive/components/fancy_filter/filter_selector/GoalStatus';
import {booleanFilters} from 'main/components/tables/interactive/components/fancy_filter/booleanFilters';
import {t} from 'shared/core';
import ReviewEmployee from 'main/components/tables/interactive/components/fancy_filter/filter_selector/ReviewEmployee';
import ReviewCycle from 'main/components/tables/interactive/components/fancy_filter/filter_selector/ReviewCycle';
import ReviewQuestion from 'main/components/tables/interactive/components/fancy_filter/filter_selector/ReviewQuestion';
import PtoPolicy from 'main/components/tables/interactive/components/fancy_filter/filter_selector/PtoPolicy';
import PayrollUpdateStatus from 'main/components/tables/interactive/components/fancy_filter/filter_selector/PayrollUpdateStatus';

const FancyFilterSelector = observer(({filterKey, filter, filterUpdated, filterDeleted, Wrapper, models}) => {
  if (booleanFilters.includes(filterKey)) {
    return <Wrapper
      title={t(`components.tables.fancy_filters.boolean_filter_selected.${filterKey}`)}
      onRemove={() => filterDeleted(filterKey)}
      booleanFilter
    />;
  }

  switch (filterKey) {
    case 'location':
      return <Location filter={filter} filterKey={filterKey} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
    case 'department':
      return <Department filter={filter} filterKey={filterKey} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
    case 'employment_status':
      return <EmploymentStatus filter={filter} filterKey={filterKey} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
    case 'employment_type':
      return <EmploymentType filter={filter} filterKey={filterKey} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
    case 'pto_policy':
      return <PtoPolicy filter={filter} filterKey={filterKey} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
    case 'candidate_status':
      return <CandidateStatus filter={filter} filterKey={filterKey} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
    case 'candidate_tags':
      return <CandidateTags filter={filter} filterKey={filterKey} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
    case 'candidate_positions':
      return <CandidatePositions filter={filter} filterKey={filterKey} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
    case 'candidate_ratings':
      return <CandidateRatings filter={filter} filterKey={filterKey} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
    case 'goal_status':
      return <GoalStatus filter={filter} filterKey={filterKey} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
    case 'goal_employee':
      return <GoalEmployee filter={filter} filterKey={filterKey} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
    case 'review_employee':
      return <ReviewEmployee filter={filter} filterKey={filterKey} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper} models={models}/>;
    case 'review_cycle':
      return <ReviewCycle filter={filter} filterKey={filterKey} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
    case 'review_question':
      return <ReviewQuestion filter={filter} filterKey={filterKey} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper} models={models}/>;
    case 'payroll_update_status':
      return <PayrollUpdateStatus filter={filter} filterKey={filterKey} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
    default:
      return null;
  }
});

export default FancyFilterSelector;
